import { WebSocketProxy } from './websocketProxy';

import './handlers';

window.WebSocket = WebSocketProxy;
